// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"2865ba9c","156":"e60bc72f","257":"4ad7e21a","465":"fb3a19d0","484":"6ac324ee","621":"e5042bef","787":"7fffb541","892":"a4cb24a9"}[chunkId] + ".chunk.js";
};